var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tags",class:_vm.className},[_c('div',{staticClass:"Tags-Title Title"},[_vm._v(" Темы ")]),_c('div',{staticClass:"Tags-Content"},[(_vm.isLoading)?_c('div',{staticClass:"ServerInfo"},[_vm._v(" Loading... ")]):_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.id,staticClass:"Tag",style:({
          marginBottom: _vm.marginBottom * tag.weight + 'px',
          marginLeft: _vm.marginLeft * tag.weight + 'px',
          paddingRight: _vm.padding * tag.weight + 'px',
          paddingLeft: _vm.padding * tag.weight + 'px',
          fontSize: _vm.fontSize * tag.weight + 'rem'
        })},[_vm._v(" #"+_vm._s(tag.name)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }